import React, { Component } from 'react';
import {
  Input,
  Form,
  Message,
  // Checkbox,
  // Field,
  CascaderSelect,
} from '@alifd/next';
import styles from './index.module.scss';
import Global from '@/utils/global';
import { provinceAndCity } from '@/services/fetchs';

// @ts-ignore - 忽略整个文件的类型检查以避免复杂的类组件类型问题

const FormItem = Form.Item;
const formItemLayout = {
  style: { width: '350px' },
  // labelCol: {
  //   fixedSpan: 5,
  // },
  // wrapperCol: {
  //   span: 16,
  // },
};

const statusTxt = {
  PAST: '已过期',
  DISABLE: '已提交',
  ENABLE: '提交',
};

interface FormRenderProps {
  isHistory?: boolean;
  content: any;
  [key: string]: any;
}

interface FormRenderState {
  addressTree: any[];
  form_order: any;
  mainDt: any;
  receiver: any;
  param: any;
  status: string;
  [key: string]: any;
}

// 使用 any 类型来避免 TypeScript 类型检查问题
class FormRender extends (Component as any)<FormRenderProps, FormRenderState> {
  public postData: any = { receiver: {} };
  public originData: any = {};
  public provinceAndCityMap: any = {};
  public field: any;

  constructor(props: FormRenderProps) {
    super(props);
    const { isHistory, content } = props;
    (this as any).state = {
      // name: '',
      // mobile: '',
      // address: '',
      // otherInfo: '',
      // area: '',
      // province: '',
      // city: '',
      // selectedValues: [],
      // options: [],
      addressTree: [],
      form_order: {},
      // disabled: false,
      ...(this as any).props,
      mainDt: {
        actionType: content.actionType,
        operateId: content.operateId,
      },
      receiver: content.param?.receiver,
      param: content.param,
      status:
        // eslint-disable-next-line no-nested-ternary
        content?.status === 'DISABLE'
          ? 'DISABLE'
          : isHistory
          ? 'PAST'
          : 'ENABLE', // PAST: 过期; DISABLE: 已提交;
    };
  }



  componentDidMount() {
    const { receiver, param, status } = this.state;
    this.postData = {
      ...param,
      receiver: {
        ...receiver,
      },
    };

    this.originData = { ...this.postData };

    this.setState(
      {
        ...receiver,
        // selectedValues: [receiver.province, receiver.city, receiver.area],
      },
      () => {
        this.forceUpdate();
      },
    );
    this.loadAreaOptionsData(86).then((res) => {
      this.setState({
        addressTree: res,
      });
    });

    if (status !== 'DISABLE') {
      setTimeout(() => {
        this.setState({
          // eslint-disable-next-line react/no-unused-state
          status: 'PAST',
        });
      }, 180000);
    }

    // this.dealProvinceAndCity({ size: 400 });
  }

  UNSAFE_componentWillReceiveProps() {
    this.loadAreaOptionsData(86).then((res) => {
      this.setState({
        addressTree: res,
      });
    });
  }

  loadAreaOptionsData = (parentId) => {
    if (Global.provinceAndCity[parentId]) {
      return Promise.resolve(Global.provinceAndCity[parentId]);
    }

    return provinceAndCity({ parentId, size: 400 }).then((res) => {
      if (res.success && Array.isArray(res.data)) {
        const data = res.data.map((item) => ({
          label: item.Province,
          value: item.Province,
          id: item.id,
          parentId: item.ParentId,
        }));

        Global.provinceAndCity[parentId] = data;
        return Promise.resolve(data);
      }
      return Promise.resolve([]);
    });
  };

  loadAddressData = async (data) => {
    const { id } = data;
    const childrenData = await this.loadAreaOptionsData(id);
    // eslint-disable-next-line react/no-access-state-in-setstate
    const newAddressTree = this.state.addressTree.slice();
    newAddressTree.forEach((item) => {
      if (item.id === id) {
        // eslint-disable-next-line no-param-reassign
        item.children = childrenData;
      } else if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((child) => {
          if (child.id === id) {
            // eslint-disable-next-line no-param-reassign
            child.children = childrenData.map((it) => ({
              ...it,
              isLeaf: true,
            }));
          }
        });
      }
    });
    this.setState({
      addressTree: newAddressTree,
    });
  };

  addressChange = (value) => {
    const { form_order } = this.state;
    // eslint-disable-next-line no-param-reassign
    value = value || {};
    // 省市区存入state中
    form_order.recipientProvince = value.info && value.info[0];
    form_order.recipientCity = value.info && value.info[1];
    form_order.recipientDistrict = value.info && value.info[2];
    form_order.districtCode = value.value || '';

    this.setState({
      form_order,
      // citymsg: form_order,
      // resetFlag: false
    });
  };

  deepEqual(obj1, obj2) {
    if (obj1 === obj2) return true;

    if (
      typeof obj1 !== 'object' ||
      typeof obj2 !== 'object' ||
      obj1 === null ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  render() {
    const { receiver, onSendQuestion, mainDt } = this.state;
    // const {content} = this.p
    const { addressTree, status } = this.state;

    return (
      <div className={styles.formRenderSty}>
        <Form
          className={styles.formSty}
          {...formItemLayout}
          labelAlign="left"
          labelTextAlign="right"
          field={this.field}
          size="small"
        >
          <Form.Item label="收件人姓名" required size="small">
            <Input defaultValue={receiver.name} name="name" />
          </Form.Item>
          <Form.Item label="收件人电话" size="small" required>
            <Input name="mobile" defaultValue={receiver.mobile} />
          </Form.Item>
          <Form.Item label="收件人省市区" size="small">
            <CascaderSelect
              defaultValue={`${receiver.province}/${receiver.city}/${receiver.area}`}
              // value={selectedValues}
              style={{ width: '100%' }}
              dataSource={addressTree}
              loadData={this.loadAddressData}
              onChange={(a: any, __: any, extra: any) => {
                const { selectedPath } = extra;
                this.postData.receiver = {
                  ...this.postData.receiver,
                  area: selectedPath[2].value,
                  areaCode: selectedPath[2].id,

                  city: selectedPath[1].value,
                  cityCode: selectedPath[1].id,

                  province: selectedPath[0].value,
                  provinceCode: selectedPath[0].id,
                };
                // if (selectedPath) {
                //     this.setState({
                //         provinceAndCity: selectedPath.map((it) => it.value)
                //     })
                //     const midArr = selectedPath.map(item => {
                //         return item.label;
                //     });
                //     this.addressChange({ value: a, info: midArr });
                // } else {
                //     provinceAndCity([]);
                // }
              }}
            />
          </Form.Item>
          <FormItem
            label="详细地址"
            required
            size="small"
            requiredMessage="详细地址很重要哦！！！"
          >
            <Input.TextArea
              defaultValue={receiver.address}
              // {...init('address', { initValue: address })}
              name="address"
              maxLength={100}
              hasLimitHint
            />
          </FormItem>
          <FormItem {...({ style: { display: 'flex', justifyContent: 'flex-end' } } as any)}>
            <Form.Submit
              disabled={status !== 'ENABLE'}
              className={styles.buttons}
              onClick={(v, e) => {
                // const value = his.field.getValues();

                this.postData = {
                  ...this.postData,
                  receiver: {
                    ...this.postData.receiver,
                    ...(v && typeof v === 'object' ? v : {}),
                  },
                };

                if (this.deepEqual(this.postData, this.originData)) {
                  Message.warning('没有改动，无法提交！');
                  return;
                }
                onSendQuestion('确认提交', {
                  ...mainDt,
                  actionParam: {
                    ...this.postData,
                  },
                });
                this.setState({
                  status: 'DISABLE',
                });
              }}
            >
              {statusTxt[status] ?? '提交'}
            </Form.Submit>
          </FormItem>

          {/* {
                Object.keys(content).map((item, index) => {
                  return <Form.Item label={content[item]} key={index} >
                    <Input></Input>
                  </Form.Item>
                })
              } */}
        </Form>
      </div>
    );
  }
}

export default FormRender;
